import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class ApprovedDialog extends Vue {
    @Prop() visible: false
    @Prop() data: {
        isReturn: number;
    }
    isAgreeOptions = [
        {label: '否', value: '0'},
        {label: '是', value: '1'},
    ]

    disBtn = false

    status = 0
    formData = {
        reviewIdea: '',
        isAgreeRevoke: '0', // 审批通过是否允许提交人撤回，默认'否'
    }

    //
    created() {
        this.formData.isAgreeRevoke = this.data.isReturn == 1 ? '1' : '0'
    }

    /*
    * methods*/
    closeReviewDialog() {
        this.formData.reviewIdea = ''
        this.formData.isAgreeRevoke = ''
        this.$emit('handleClose', false)
    }

    confirmReviewDialog() {
        this.$emit('doConfirm',this.formData)
    }
}
